import axios from "api/axios";

const MEETING_DATE_ATTRIBUTE_ID = "Ub0V9Z06aBc";
const TRACKER_RECORD_FIELDS = "trackedEntity,orgUnit,attributes[attribute,displayName,value]";
const DPAT_PAGE_SIZE = 5000;

const DPAT_MEETING_TYPES = [
  { label: "Spatial Planning Committee (SPC)", phrases: ["spatial planning committee", "spatial planning"] },
  { label: "Technical Sub-Committee", phrases: ["technical sub-committee", "technical sub committee", "technical subcommittee"] },
  { label: "Entity Tender Committee (ETC)", phrases: ["entity tender committee", "entity tender"] },
  { label: "Town Hall Meetings", phrases: ["town hall"] },
  { label: "Management Meetings", phrases: ["management meeting"] },
  { label: "GA", phrases: ["general assembly"] },
  { label: "EC", phrases: ["executive committee"] },
  { label: "PRCC", phrases: ["prcc"] },
  { label: "Audit Committee", phrases: ["audit committee"] },
  { label: "Statutory Sub - Committee", phrases: ["statutory sub"] },
  { label: "Sub Structure Committee", phrases: ["sub structure committee", "sub-structure committee"] },
];

const TRACKER_LINKS = [
  { kind: "meetings", title: "Meetings Tracker", programId: "Ch38jUWJpUR", names: ["Meetings Tracker", "Meetings"], phrases: ["spatial planning committee", "technical sub-committee", "technical sub committee", "entity tender", "town hall", "management meeting", "general assembly", "executive committee", "audit committee", "statutory sub", "committee meeting", "meeting", "meetings"] },
  { kind: "aap", title: "Annual Action Plan Tracker", programId: "ArLnAxhykoz", names: ["Annual Action Plan (AAP)", "Annual Action Plan"], exclude: ["baseline", "target"], phrases: ["annual action plan", "aap"] },
  { kind: "projects", title: "Projects and Programmes", programId: "g3wMUKEMmH3", names: ["Projects & Programmes Register (P&P)", "Projects & Programmes", "Projects and Programmes"], phrases: ["projects and programmes", "project register", "capital project", "project"] },
  { kind: "generic", title: "Operational Health Facility Tracker", programId: "", names: ["Operational Health Facility Tracker", "Operational Health Facility", "Health Facility Tracker"], phrases: ["health facility", "health facilities", "operational health", "chps"] },
  { kind: "generic", title: "School Profile Tracker", programId: "g27TeeehRQC", names: ["School Profile Tracker", "School Profile"], phrases: ["school profile", "schools", "school", "education oversight", "education"] },
  { kind: "generic", title: "Internally Generated Fund Tracker", programId: "dYNmYGtArrK", names: ["Internally Generated Fund Tracker", "IGF Tracker"], phrases: ["internally generated fund", "igf revenue", "igf collection", "igf"] },
  { kind: "generic", title: "Revenue Tracker", programId: "", names: ["Revenue Tracker"], phrases: ["revenue mobilisation", "revenue mobilization", "revenue"] },
  { kind: "generic", title: "Budget Allocation Tracker", programId: "", names: ["Budget Allocation Tracker"], phrases: ["budget allocation", "approved budget", "budget"] },
  { kind: "generic", title: "Expenditure Tracker", programId: "", names: ["Expenditure Tracker", "Expenditure"], phrases: ["expenditure"] },
  { kind: "generic", title: "Bill Tracker", programId: "", names: ["Bill Tracker"], phrases: ["bill distribution", "billing", "bills"] },
  { kind: "generic", title: "Computerized Billing System", programId: "", names: ["Computerized Billing System"], phrases: ["computerized billing", "computerised billing"] },
  { kind: "generic", title: "Permits Request Tracker", programId: "w2au8V5taU8", names: ["Permits Request Tracker", "Permit Request Tracker"], phrases: ["building permit", "permit application", "permits", "permit"] },
  { kind: "generic", title: "Street Naming Tracker", programId: "joUkaNeiZ0O", names: ["Street Naming Tracker", "Street Naming"], phrases: ["street naming", "street name"] },
  { kind: "generic", title: "Sanitation and Waste Tracker", programId: "", names: ["Sanitation and Waste Tracker", "Sanitation & Waste Tracker"], phrases: ["sanitation", "solid waste", "waste management", "environmental sanitation"] },
  { kind: "generic", title: "Dumping Site or engineered landfills", programId: "", names: ["Dumping Site or engineered landfills", "Engineered Landfills"], phrases: ["engineered landfill", "dumping site", "landfill"] },
  { kind: "generic", title: "Food Vendors Register", programId: "abiQOocP8YA", names: ["Food Vendors Register", "Food Vendor Register"], phrases: ["food vendor", "food vendors"] },
  { kind: "generic", title: "Service Providers Tracker", programId: "nGFVo65uUE4", names: ["Service Providers Tracker", "Service Providers"], phrases: ["service provider", "service providers"] },
  { kind: "generic", title: "Sport Facility Tracker", programId: "", names: ["Sport Facility Tracker", "Sport Facility"], phrases: ["sport facility", "sports facility", "sporting facility"] },
  { kind: "generic", title: "People With Disability Tracker", programId: "", names: ["People With Disability Tracker", "People With Disability", "PWD Tracker"], phrases: ["people with disability", "persons with disability", "pwd"] },
  { kind: "generic", title: "Social Inclusive Program Beneficiaries Tracker", programId: "", names: ["Social Inclusive Program Beneficiaries Tracker", "Program Beneficiaries Tracker"], phrases: ["programme beneficiaries", "program beneficiaries", "beneficiaries"] },
  { kind: "generic", title: "Social Inclusive Program Tracker", programId: "", names: ["Social Inclusive Program Tracker", "Social Inclusive Programme Tracker"], phrases: ["social inclusive", "social protection", "inclusive programme", "inclusive program"] },
  { kind: "generic", title: "Boundary Dispute Tracker", programId: "", names: ["Boundary Dispute Tracker", "Boundary Dispute"], phrases: ["boundary dispute", "boundary"] },
  { kind: "generic", title: "Capacity Building Needs", programId: "", names: ["Capacity Building Needs"], phrases: ["capacity building", "capacity development"] },
  { kind: "generic", title: "Consulting And Contractors", programId: "", names: ["Consulting And Contractors", "Consulting and Contractors"], phrases: ["consulting and contractors", "contractor", "contractors"] },
  { kind: "generic", title: "Decisions And Complaints", programId: "n8WIhwDrAO7", names: ["Decisions And Complaints", "Decisions and Complaints"], phrases: ["decisions and complaints", "complaint", "complaints"] },
  { kind: "generic", title: "Disaster Tracker", programId: "", names: ["Disaster Tracker", "Disaster"], phrases: ["disaster", "flood", "emergency response"] },
  { kind: "generic", title: "District Assembly Departments", programId: "mAEretIhuqM", names: ["District Assembly Departments"], phrases: ["assembly department", "departments established", "department"] },
  { kind: "generic", title: "Job Tracker", programId: "", names: ["Job Tracker", "Jobs Tracker"], phrases: ["job creation", "jobs created", "employment"] },
  { kind: "generic", title: "Key Critical Poverty Issues Tracker", programId: "", names: ["Key Critical Poverty Issues Tracker", "Critical Poverty Issues Tracker"], phrases: ["poverty issues", "critical poverty", "poverty"] },
  { kind: "generic", title: "Statutory Member Tracker", programId: "AJDfCnHCQ2j", names: ["Statutory Member Tracker", "Statutory Members Tracker"], phrases: ["statutory member", "statutory members", "assembly member"] },
  { kind: "generic", title: "Logistic Tracker", programId: "", names: ["Logistic Tracker", "Logistics Tracker"], phrases: ["logistics", "logistic"] },
  { kind: "generic", title: "Vulnerability Tracker", programId: "", names: ["Vulnerability Tracker"], phrases: ["vulnerability", "vulnerable"] },
  { kind: "generic", title: "Legal Case Tracker", programId: "", names: ["Legal Case Tracker", "Legal Cases Tracker"], phrases: ["legal case", "court case", "litigation"] },
  { kind: "generic", title: "LED Related Programs", programId: "", names: ["LED Related Programs", "LED Related Programme"], phrases: ["local economic development", "led programme", "led program"] },
  { kind: "generic", title: "Property Tracker", programId: "", names: ["Property Tracker", "Properties Tracker"], phrases: ["property rate", "properties", "property"] },
  { kind: "generic", title: "Marketing Business Tracker", programId: "", names: ["Marketing Business Tracker", "Marketing Business"], phrases: ["marketing business", "market facility", "markets"] },
  { kind: "generic", title: "Payment Point Tracker", programId: "", names: ["Payment Point Tracker", "Payment Point"], phrases: ["payment point", "revenue point"] },
  { kind: "generic", title: "Audit Issues Tracker", programId: "Z3qMezPtpEb", names: ["Audit Issues Tracker", "Audit Issues"], phrases: ["audit issue", "audit recommendation", "audit"] },
  { kind: "generic", title: "Annual Progress Report Tracker", programId: "", names: ["Annual Progress Report Tracker", "Annual Progress Report"], phrases: ["annual progress report", "progress report"] },
  { kind: "generic", title: "Publications Tracker", programId: "X5kGqVpbGoN", names: ["Publications Tracker", "Publication Tracker"], phrases: ["publication", "publications", "public disclosure"] },
  { kind: "generic", title: "Sub Structure Activity Tracker", programId: "p1vYbSWkgyD", names: ["Sub Structure Activity Tracker", "Sub-Structure Activity Tracker"], phrases: ["sub structure activity", "sub-structure activity"] },
  { kind: "generic", title: "Sub Structure Committee", programId: "vkJZ5R2mSJ3", names: ["Sub Structure Committee", "Sub-Structure Committee"], phrases: ["sub structure", "sub-structure", "zonal council", "urban council", "town council", "area council"] },
  { kind: "generic", title: "Inspectorate Unit Activity Tracker", programId: "", names: ["Inspectorate Unit Activity Tracker"], phrases: ["inspectorate activity", "building inspectorate activity"] },
  { kind: "generic", title: "Inspectorate Unit Establishment Tracker", programId: "pYvmkB4s6Nq", names: ["Inspectorate Unit Establishment Tracker"], phrases: ["inspectorate unit", "building inspectorate"] },
  { kind: "generic", title: "District General Tracker", programId: "RwWtjFaorvN", names: ["District General Tracker"], phrases: ["client service", "public hotline", "district general"] },
  { kind: "generic", title: "Evaluation And PME Tracker", programId: "", names: ["Evaluation And PME Tracker", "PME Tracker"], phrases: ["monitoring and evaluation", "pme"] },
  { kind: "generic", title: "Agriculture Support", programId: "", names: ["Agriculture Tracker", "Agric Tracker"], phrases: ["agriculture", "agric", "farmer"] },
  { kind: "transport", title: "Transport Operators", programId: "R5MX47LvztN", names: ["Transport Operators", "Transporters"], phrases: ["transport operator", "transport operators", "road safety"] },
];

const AAP_STOP_WORDS = new Set([
  "and", "the", "for", "with", "approved", "programme", "program", "programmes", "programs",
  "activity", "activities", "including", "achieved", "implementation", "implemented", "percent",
  "least", "from", "that", "this", "their", "annual", "action", "plan",
]);

function normalizeText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function phraseScore(phrase, text) {
  const normalizedPhrase = normalizeText(phrase);
  const normalizedText = normalizeText(text);
  if (!normalizedPhrase || !normalizedText.includes(normalizedPhrase)) return 0;
  const words = normalizedPhrase.split(" ").filter(Boolean);
  return words.length * 8 + normalizedPhrase.length;
}

function scoreLink(link, kpiName, scoringText) {
  const nameScore = Math.max(0, ...link.phrases.map((phrase) => phraseScore(phrase, kpiName)));
  if (nameScore > 0) return nameScore * 10;
  const guideScore = Math.max(
    0,
    ...link.phrases
      .filter((phrase) => normalizeText(phrase).split(" ").length > 1)
      .map((phrase) => phraseScore(phrase, scoringText)),
  );
  return guideScore;
}

function findKnownMeetingTypes(text) {
  const normalized = normalizeText(text);
  return DPAT_MEETING_TYPES.filter((meetingType) =>
    meetingType.phrases.some((phrase) => normalized.includes(phrase)),
  );
}

function extractAapFocus(kpiText) {
  const text = String(kpiText || "").replace(/\s+/g, " ").trim();
  const match =
    text.match(/approved\s+(.+?)\s+in\s+the\s+(?:\d{4}\s+)?annual action plan/i) ||
    text.match(/(.+?)\s+in\s+the\s+(?:\d{4}\s+)?annual action plan/i);
  const subject = String(match?.[1] || "")
    .replace(/^(?:at least\s+\d+\s*%?\s*(?:of\s+)?)/i, "")
    .replace(/^(?:the\s+)?approved\s+/i, "")
    .trim();
  const including = subject.match(/including\s+([^)]+)/i)?.[1] || "";
  const core = subject.replace(/\([^)]*\)/g, " ").replace(/&/g, " and ");
  const tokens = [];
  [core, including].forEach((phrase) => {
    normalizeText(phrase)
      .split(" ")
      .filter((token) => token.length > 3 && !AAP_STOP_WORDS.has(token))
      .forEach((token) => {
        if (!tokens.includes(token)) tokens.push(token);
      });
  });
  return { label: subject || "Annual Action Plan activities", tokens };
}

function collectAttributes(record) {
  const enrollmentAttributes = (Array.isArray(record?.enrollments) ? record.enrollments : []).flatMap(
    (enrollment) => (Array.isArray(enrollment?.attributes) ? enrollment.attributes : []),
  );
  const attributes = [...(Array.isArray(record?.attributes) ? record.attributes : []), ...enrollmentAttributes];
  const byKey = new Map();
  attributes.forEach((attribute) => {
    const id = attribute?.attribute || attribute?.trackedEntityAttribute || attribute?.id || "";
    const label = attribute?.displayName || attribute?.displayFormName || id;
    const key = id || label;
    if (!key) return;
    const existing = byKey.get(key);
    if (!existing || (!existing.value && attribute?.value)) byKey.set(key, attribute);
  });
  return Array.from(byKey.values());
}

function findAttribute(attributes, labels, ids = []) {
  const needles = labels.map((label) => normalizeText(label)).filter(Boolean);
  for (const attribute of attributes) {
    const id = attribute?.attribute || attribute?.trackedEntityAttribute || attribute?.id;
    if (id && ids.includes(id) && attribute?.value) return String(attribute.value);
  }
  for (const attribute of attributes) {
    const label = normalizeText(attribute?.displayName || attribute?.displayFormName || "");
    if (needles.includes(label) && attribute?.value) return String(attribute.value);
  }
  for (const attribute of attributes) {
    const label = normalizeText(attribute?.displayName || attribute?.displayFormName || "");
    if (needles.some((needle) => needle.length > 4 && label.includes(needle)) && attribute?.value) {
      return String(attribute.value);
    }
  }
  return "";
}

function recordInYear(record, year) {
  if (!year) return true;
  const attributes = collectAttributes(record);
  const explicitYear = findAttribute(attributes, ["Year", "Select Year"], ["pWkYqcKukAY", "Ik7fouv4KOA"]);
  if (explicitYear) return String(explicitYear).includes(String(year));
  const dated = attributes.some((attribute) => String(attribute?.value || "").includes(String(year)));
  if (dated) return true;
  const hasYearSignal = attributes.some(
    (attribute) => /year|date/i.test(attribute?.displayName || "") || /\b(19|20)\d{2}\b/.test(String(attribute?.value || "")),
  );
  return !hasYearSignal;
}

function recordBlob(record) {
  return normalizeText(
    collectAttributes(record)
      .map((attribute) => `${attribute?.displayName || ""} ${attribute?.value || ""}`)
      .join(" "),
  );
}

function matchesMeetingType(record, meetingTypes) {
  if (!meetingTypes?.length) return true;
  const attributes = collectAttributes(record);
  const meetingType = findAttribute(attributes, ["DPAT | Meeting Type", "Meeting type"], ["kghpIZgHFsT"]);
  const normalizedType = normalizeText(meetingType);
  return meetingTypes.some((type) =>
    [type.label, ...(type.phrases || [])].some((phrase) => {
      const needle = normalizeText(phrase);
      return needle && (normalizedType === needle || normalizedType.includes(needle));
    }),
  );
}

function matchesTokens(record, tokens) {
  if (!tokens?.length) return true;
  const blob = recordBlob(record);
  return tokens.some((token) => blob.includes(token));
}

function quarterFromDate(value) {
  const isoMatch = String(value || "").match(/\b(19|20)\d{2}-(\d{2})-\d{2}/);
  const month = isoMatch ? Number(isoMatch[2]) : null;
  if (month >= 1 && month <= 12) return `Q${Math.ceil(month / 3)}`;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return `Q${Math.ceil((parsed.getMonth() + 1) / 3)}`;
}

function isAchievedState(value) {
  const text = normalizeText(value);
  if (!text || /\b(not|un|pending|partial|ongoing|yet)\b/.test(text)) return false;
  return /(complet|implement|achiev|done)/.test(text);
}

function buildSource(link, kpiText, scoringText, year) {
  const combined = `${kpiText || ""} ${scoringText || ""}`;
  const reviewYear = String(year || "").trim();
  const meetingTypes = link.kind === "meetings" ? findKnownMeetingTypes(combined) : [];
  const focus = link.kind === "aap" ? extractAapFocus(combined) : { label: link.title, tokens: [] };
  const filterLabel = meetingTypes.length
    ? meetingTypes.map((type) => type.label).join(" or ")
    : focus.tokens.length
      ? focus.label
      : link.title;

  return {
    kind: link.kind,
    title: link.title,
    programId: link.programId,
    names: link.names,
    exclude: link.exclude || [],
    filterLabel,
    searchQuery: meetingTypes.length
      ? meetingTypes.map((type) => type.label).join("|")
      : focus.tokens.join(" "),
    qMode: focus.tokens.length > 1 ? "any" : "",
    year: reviewYear,
    matches(record) {
      if (!recordInYear(record, reviewYear)) return false;
      if (link.kind === "meetings") return matchesMeetingType(record, meetingTypes);
      if (link.kind === "aap" || link.kind === "projects" || link.kind === "transport") {
        return matchesTokens(record, focus.tokens);
      }
      return true;
    },
    summarize(rows) {
      if (link.kind === "meetings") {
        const quarters = { Q1: 0, Q2: 0, Q3: 0, Q4: 0 };
        rows.forEach((row) => {
          const quarter = quarterFromDate(row.cells["Meeting date"] || row.cells["DPAT | Meeting Date"]);
          if (quarters[quarter] !== undefined) quarters[quarter] += 1;
        });
        return {
          total: rows.length,
          quarters,
          detail: `${rows.length} ${filterLabel} record${rows.length === 1 ? "" : "s"}${reviewYear ? ` in ${reviewYear}` : ""}.`,
        };
      }
      if (link.kind === "aap") {
        const completed = rows.filter((row) =>
          isAchievedState(row.cells["Activity State"] || row.cells["Activity state"]),
        ).length;
        const percent = rows.length > 0 ? Math.round((completed / rows.length) * 100) : 0;
        return {
          total: rows.length,
          quarters: null,
          detail: rows.length
            ? `${completed} of ${rows.length} activities are recorded as completed or implemented (${percent}%).`
            : "No matching Annual Action Plan activities were found.",
        };
      }
      return {
        total: rows.length,
        quarters: null,
        detail: `${rows.length} record${rows.length === 1 ? "" : "s"} from ${link.title}${reviewYear ? ` for ${reviewYear}` : ""}.`,
      };
    },
  };
}

function chooseCatalogLink(kpiName, scoringText) {
  let bestLink = null;
  let bestScore = 0;
  TRACKER_LINKS.forEach((link) => {
    const score = scoreLink(link, kpiName, scoringText);
    if (score > bestScore) {
      bestScore = score;
      bestLink = link;
    }
  });
  return bestLink;
}

const LIVE_NAME_IGNORE = new Set([
  "tracker", "register", "district", "unit", "related", "system", "sheet", "activity",
  "programme", "program", "and", "the", "for", "with",
]);

function chooseLiveProgram(programs, kpiName) {
  const text = normalizeText(kpiName);
  let best = null;
  let bestScore = 0;
  (programs || []).forEach((program) => {
    const tokens = normalizeText(program?.displayName || program?.name)
      .split(" ")
      .filter((token) => token.length > 4 && !LIVE_NAME_IGNORE.has(token));
    const hits = tokens.filter((token) => text.includes(token));
    const score = hits.reduce((sum, token) => sum + token.length, 0);
    if (score > bestScore) {
      bestScore = score;
      best = program;
    }
  });
  if (!best || bestScore < 8) return null;
  return {
    kind: "generic",
    title: best.displayName || best.name || "Tracker",
    programId: best.id,
    names: [best.displayName || best.name],
    exclude: [],
    phrases: [],
  };
}

export function resolveKpiTrackerSource(kpiText, year, scoringText = "", programs = []) {
  const catalogLink = chooseCatalogLink(kpiText, scoringText);
  const link = catalogLink || chooseLiveProgram(programs, kpiText);
  if (!link) return null;
  return buildSource(link, kpiText, scoringText, year);
}

function extractRecords(data) {
  return data?.instances || data?.trackedEntities || data?.trackedEntityInstances || [];
}

async function fetchPrograms() {
  const response = await axios.get("/programs", {
    params: {
      paging: false,
      fields: "id,displayName,programType",
    },
  });
  return (response?.data?.programs || []).filter((program) => {
    const programType = String(program?.programType || "").toUpperCase();
    return programType === "WITH_REGISTRATION" || program?.trackedEntityType || program?.id;
  });
}

function findProgram(programs, source) {
  const pool = (programs || []).filter((program) => {
    const name = normalizeText(program?.displayName || program?.name);
    return !(source.exclude || []).some((part) => name.includes(part));
  });
  for (const candidate of source.names || []) {
    const exact = pool.find((program) => normalizeText(program?.displayName || program?.name) === normalizeText(candidate));
    if (exact) return exact;
  }
  for (const candidate of source.names || []) {
    const needle = normalizeText(candidate);
    const partial = pool.find((program) => normalizeText(program?.displayName || program?.name).includes(needle));
    if (partial) return partial;
  }
  if (source.programId) {
    return pool.find((program) => program.id === source.programId) || { id: source.programId, displayName: source.title };
  }
  return null;
}

async function fetchTrackedEntities(orgUnitId, programId, extraParams = "") {
  const response = await axios.get(
    `/tracker/trackedEntities?orgUnit=${orgUnitId}&program=${programId}&pageSize=${DPAT_PAGE_SIZE}&fields=${TRACKER_RECORD_FIELDS}${extraParams}`,
  );
  return extractRecords(response?.data || {});
}

function buildDisplayRows(records) {
  const preferred = ["name", "title", "type", "sector", "status", "state", "date", "year"];
  const labels = [];
  records.forEach((record) => {
    collectAttributes(record).forEach((attribute) => {
      const label = attribute?.displayName || attribute?.displayFormName;
      if (label && !labels.includes(label)) labels.push(label);
    });
  });
  labels.sort((left, right) => {
    const leftRank = preferred.findIndex((item) => normalizeText(left).includes(item));
    const rightRank = preferred.findIndex((item) => normalizeText(right).includes(item));
    return (leftRank === -1 ? 99 : leftRank) - (rightRank === -1 ? 99 : rightRank);
  });
  const columns = labels.slice(0, 6).map((label) => ({ label }));
  const rows = records.map((record, index) => {
    const attributes = collectAttributes(record);
    const cells = {};
    columns.forEach((column) => {
      const match = attributes.find((attribute) => (attribute?.displayName || attribute?.displayFormName) === column.label);
      cells[column.label] = match?.value ? String(match.value) : "";
    });
    return {
      id: record?.trackedEntity || record?.trackedEntityInstance || `record-${index + 1}`,
      cells,
    };
  });
  return { columns, rows };
}

export async function loadKpiTrackerRecords({ kpiText, scoringText = "", year, orgUnitId, source }) {
  const programs = await fetchPrograms().catch(() => []);
  const resolved = source || resolveKpiTrackerSource(kpiText, year, scoringText, programs);
  if (!resolved || !orgUnitId) {
    return { linked: false, programId: "", programName: "", rows: [], columns: [], summary: null };
  }

  const program = findProgram(programs, resolved);
  const programId = program?.id || resolved.programId;
  if (!programId) {
    return { linked: false, programId: "", programName: resolved.title, rows: [], columns: [], summary: null };
  }

  let records = [];
  if (resolved.kind === "meetings" && resolved.year) {
    records = await fetchTrackedEntities(
      orgUnitId,
      programId,
      `&filter=${MEETING_DATE_ATTRIBUTE_ID}:GE:${resolved.year}-01-01:LE:${resolved.year}-12-31`,
    );
  } else if (resolved.year && (resolved.kind === "aap" || resolved.kind === "projects")) {
    records = await fetchTrackedEntities(
      orgUnitId,
      programId,
      `&startDate=${resolved.year}-01-01&endDate=${resolved.year}-12-31`,
    );
  } else {
    records = await fetchTrackedEntities(orgUnitId, programId);
  }

  let matched = (Array.isArray(records) ? records : []).filter((record) => resolved.matches(record));
  if (matched.length === 0 && resolved.year) {
    records = await fetchTrackedEntities(orgUnitId, programId);
    matched = (Array.isArray(records) ? records : []).filter((record) => resolved.matches(record));
  }

  const { columns, rows } = buildDisplayRows(matched);
  return {
    linked: true,
    source: resolved,
    programId,
    programName: program?.displayName || resolved.title,
    title: resolved.title,
    filterLabel: resolved.filterLabel,
    year: resolved.year,
    columns,
    rows,
    summary: resolved.summarize(rows),
  };
}
